import React, {Component} from 'react';
import _ from 'lodash';

export class DocumentTypeFilter extends Component {
  constructor(props) {
    super(props)
    
    this.renderType = this.renderType.bind(this);
  }

  handleChangeType(document_type){
    this.props.handleChangeType(document_type);
  }

  renderType(document_type, index){
    return (
      <label 
        key={index} 
        onClick={this.handleChangeType.bind(this, document_type)}
        className={`btn btn-sm btn-secondary ${this.props.active_type === document_type && 'active'}`}>
        <input type="radio" name="document_type_filter" id={`document_type_filter_${index}`} autoComplete="off" defaultChecked="true" /> 
        {document_type}
      </label>
    )
  }

  render(){
    const { document_types } = this.props;
    return (
      <div className='row mb-1'>
        <div className='col-md-1'><b>ประเภท</b></div>
        <div className='col-md-11'>
          <div className="btn-group btn-group-toggle" data-toggle="buttons">
            {_.map(document_types, this.renderType)}
          </div>
        </div>
      </div>
    )
  }
}

export default DocumentTypeFilter;



// WEBPACK FOOTER //
// ./src/components/documents/filters/DocumentTypeFilter.js